import addClass from "../../utilities/add-class";
import removeClass from "../../utilities/remove-class";

/**
 * Poll for updates to batch payments that haven't finished processing.
 * @param  {Node} el Element
 * @return {Void}
 */

export default function adminFileDownload(el, props) {
  const downloadAnchorEl = el.querySelector(".admin-file-download-anchor");
  const activityIndicatorEl = el.querySelector(".activity-indicator");

  let timeoutID;

  function triggerCsvDownload(e) {
    if (downloadAnchorEl.dataset.status === "None") {
      e.preventDefault();

      removeClass(activityIndicatorEl, "activity-indicator--hidden");
      downloadAnchorEl.dataset.status = "Processing";
      downloadAnchorEl.textContent = "Please wait";

      window
        .fetch(props.endpoint, {
          credentials: "same-origin",
          headers: {
            X_CSRF_TOKEN: props.csrf_token,
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          method: props.method,
          body: JSON.stringify(props.params)
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          fetchAdminFileDownload(json);
        })
        .catch(error => {
          console.log("Request failed: ", error);
        });
    }

    if (downloadAnchorEl.dataset.status !== "Completed") {
      e.preventDefault();
    }
  }

  function fetchAdminFileDownload(download) {
    window
      .fetch("/admin/admin-file-downloads/" + download.id + ".json", {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        },
        method: "GET"
      })
      .then(function(response) {
        return response.json();
      })
      .then(updateAdminFileDownload)
      .catch(error => {
        console.log("Request failed: ", error);
      });
  }

  function updateAdminFileDownload(download) {
    // Set another timeout if this download is still processing
    if (download.status === "Processing") {
      timeoutID = window.setTimeout(fetchAdminFileDownload, 2000, download);
    } else {
      addClass(activityIndicatorEl, "activity-indicator--hidden");
      downloadAnchorEl.href = download.url;
      downloadAnchorEl.dataset.status = download.status;
      downloadAnchorEl.textContent = "Click to download";
    }
  }

  function destroy() {
    if (timeoutID) {
      window.clearTimeout(timeoutID);
    }
  }

  // Set listener
  downloadAnchorEl.addEventListener("click", triggerCsvDownload);

  return {
    destroy: destroy
  };
}
